<script lang="ts">
  import Button from 'Components/shared/Button/Button.svelte';

  type DealEndingParams = {
    id: number;
    title: string;
    company: {
      id: number;
      name: string;
      logo: string;
    };
  };

  export let dealEndingParams: DealEndingParams;

  const portalLink = `/companies/${dealEndingParams.company.id}/portal/`;

  const handleUrlOpen = () => {
    window.location.href = portalLink;
  };
</script>

<div class="container">
  <h3 class="title" data-testid="deal-title">
    {dealEndingParams.company.name} has closed their deal
  </h3>
  <div class="content">
    {#if dealEndingParams.company.logo}
      <div class="logo-container">
        <img
          src={dealEndingParams.company.logo}
          alt="Company logo"
          class="company-logo"
          data-testid="company-logo"
        />
      </div>
    {/if}
    <div class="deal-info">
      <div class="deal-info__title">
        <p data-testid="company-name">{dealEndingParams.company.name}</p>
      </div>
      <div class="deal-info__misc">
        <a href={portalLink} class="primary" data-testid="deal-info-misc">
          Follow {dealEndingParams.company.name} here
        </a>
        to learn more about the company, and for updates on future investment opportunities.
      </div>
    </div>
  </div>
  <div class="footer">
    <Button fullWidth on:click={handleUrlOpen}
      >Follow {dealEndingParams.company.name}</Button
    >
  </div>
</div>

<style lang="postcss">
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 40%;
    padding: 0.625rem;
  }

  .logo-container {
    display: flex;
    align-items: center;
    background-color: transparent;
    padding: 0.5rem;
  }

  .content {
    display: flex;
    margin-top: 1rem;
  }

  .company-logo {
    max-width: 12rem;
  }

  .deal-info {
    display: flex;
    flex-direction: column;
    margin-left: 1rem;

    & p {
      font-size: 1rem;
      font-weight: 600;
      margin: 0;
    }
  }

  .deal-info__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
  }

  .deal-info__misc {
    font-weight: 400;

    & a {
      text-decoration: underline;
    }
  }

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    padding: 1rem 3rem;
  }

  @media (max-width: 1024px) {
    .container {
      width: 60%;
    }
  }

  @media (max-width: 768px) {
    .container {
      width: 100%;
      padding: 0 1rem;
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 1rem;
    }

    .title {
      margin-bottom: 0;
    }

    .logo-container {
      justify-content: center;
    }

    .company-logo {
      max-width: 80%;
    }

    .deal-info {
      margin-left: 0;
      margin-top: 0.5rem;
    }

    .deal-info__title {
      align-items: flex-start;
    }
  }

  @media (max-width: 480px) {
    .company-logo {
      max-width: 100%;
    }
  }
</style>
